import { render, staticRenderFns } from "./AddonItem.vue?vue&type=template&id=c5c20ac0&scoped=true&"
import script from "./AddonItem.vue?vue&type=script&lang=js&"
export * from "./AddonItem.vue?vue&type=script&lang=js&"
import style0 from "./AddonItem.vue?vue&type=style&index=0&id=c5c20ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c20ac0",
  null
  
)

export default component.exports